<template>
  <div class="layer">
    <div class="mobile-menu">
      <div class="header-menu-mobile">
        <img src="../../assets/navbar/logo.png" alt="">
        <span>دریک</span>
      </div>

      <ul>
        <li @click="$router.push(item.src)" v-for="(item , index) in MobileMenuData" :key="index">
          {{ item.name }}
        </li>
      </ul>

      <div class="footer-menu-mobile">
        <p>ما را در شبکه های اجتماعی دنبال کنید</p>
        <div class="icon-div">
          <img src="../../assets/sochialNetworkIcon/facebook.png" alt="" width="30" height="30">
          <img src="../../assets/sochialNetworkIcon/instagram.png" alt="" width="30" height="30">
          <img src="../../assets/sochialNetworkIcon/twitter.png" alt="" width="30" height="30">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "the-mobile-menu",
  data() {
    return {
      MobileMenuData: [
        {name: 'خانه', src: '/'},
        {name: 'بازار ارز دیجیتال', src: '/trade'},
        {name: 'بازار طلا و سکه', src: '/goldTrade'},
        {name: 'معامله سریع (OTC)', src: ''},
        {name: 'کارمزد سطوح کاربری', src: ''},
        {name: 'بلاگ', src: ''},
        {name: '  راهنمای سایت', src: '/guide'},
        {name: 'درباره ما', src: '/about'},
        {name: ' تماس با ما', src: '/contact'},
        {name: ' سوالات متداول', src: '/qa'},
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-div {
  display: flex;
  justify-content: space-between;
  width: 100% !important;

  img {
    width: 20px !important;
    height: 20px !important;
  }
}

.layer {
  white-space: nowrap;
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(19, 23, 30, 0.7);
  z-index: 10;
  padding: 20px 0px;

  .mobile-menu {
    img {
      width: 50px;
      height: 20px;
    }

    background-color: #0B1426;
    border-radius: 5px 0 0 5px;
    display: flex;
    flex-direction: column;
    width: 100%;
    //height: calc(100vh - 50px);
    z-index: 100;
    left: 0;

    ul {
      display: flex;
      flex-direction: column;
      gap: 35px;

      li {
        font-size: 14px;
        color: #D7C8C8;
        list-style: none;
        cursor: pointer;
      }
    }

    .header-menu-mobile {
      display: flex;
      gap: 20px;
      padding: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #D7C8C8;

      span {
        font-size: 18px;
      }
    }

    .footer-menu-mobile {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      border-top: 1px solid #D7C8C8;
      bottom: 50px;

      .icon-div {
        display: flex;
        flex-direction: row;
        //gap: 20px;
        width: 100%;
        justify-content: space-around;

      }

      p {
        font-size: 12px;
      }
    }
  }
}
</style>